/**
 * liveblog App - Optimized minimal entry point
 */

const initWebComponents = async () => {
    // Dynamic public path setup (keep this synchronous as it's needed immediately)
    const dynamicPublicPath = () => {
        const AEM_CLIENT_LIB_NAME = 'dp_liveblog';
        const AEM_JS_RESOURCES_PUBLIC_PATH = `sky-aem-frontend-liveblog/clientlibs/${AEM_CLIENT_LIB_NAME}/`;

        // @ts-ignore
        const AEM_STATIC_FOLDER = window?.SkyFoundationSettings?.staticDomain || undefined;

        if (AEM_STATIC_FOLDER) {
            // @ts-ignore
            __webpack_public_path__ = process.env.NODE_ENV === 'development' ? '' : `${AEM_STATIC_FOLDER}${AEM_JS_RESOURCES_PUBLIC_PATH}`;
            // @ts-ignore
            console.info(`Override default public path __webpack_require__.p to: ${__webpack_require__.p}`);
        } else {
            // @ts-ignore
            console.warn(`PUBLIC PATH not found in window , the default public path is: ${__webpack_require__.p}`);
        }
    };

    // Set up public path immediately
    dynamicPublicPath();

    // Dynamically import all the heavy dependencies
    const [
        { liveblogCardWidget, liveblogContainerWidget },
        { default: DynamicLiveblogContainer },
        { default: DynamicLiveblogCard },
        { defineWebComponents },
    ] = await Promise.all([
        import('@sky-it-cmscomposer/liveblog-widgets'),
        import('./components/liveblog-container/dynamic-liveblog-container'),
        import('./components/liveblog-card/dynamic-liveblog-card'),
        import('./utils/web-components-utils'),
    ]);

    // Initialize web components
    const webComponentsMap = new Map();
    webComponentsMap.set(liveblogContainerWidget.tag, DynamicLiveblogContainer);
    webComponentsMap.set(liveblogCardWidget.tag, DynamicLiveblogCard);

    console.log('defineWebComponents', { webComponentsMap });
    defineWebComponents(webComponentsMap);
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWebComponents);
} else {
    initWebComponents();
}
